/** - Este Script se encarga de cargar y almacenar los recursos que estaran sieendo
 * utilizados por las demas partes del programa, entre varios tipos el mas importante
 * son las imagenes y recursos, para evitar la re descarga de recursos
 * @author Agustin Parodi - IGM (Sección: SIG)
 */

let w = /** @type {ExtendedWindow} */ (window);

//devuelve los recursos del mapa en el objeto global
w.GetRecursosDiv = function(){
    w.Recursos = {descripcion:"div con todos los recursos a usar"};
    w.Recursos.div = document.getElementsByClassName('W_DivConImagenes')[0];

    for(let elemento of w.Recursos.div.children){
        w.Recursos[elemento.getAttribute('name')] = elemento;
    }
}

//estp devuelve los recursos con ese nombre
w.GetRecurso = function(NombreRecurso){
    return w.Recursos[NombreRecurso];
}

//inicializo los recursos
w.GetRecursosDiv()

